<template>
  <div class="video-section">
    <div class="video-container">
      <video
        id="background-video"
        src="../assets/videos/Dextro-video_mit_Cortex-snd_med.mp4"
        muted="true"
        autoplay="true"
        loop="true"
        playsinline="true"
      ></video>
      <button id="toggle-mute-btn">
        <img src="../assets/sound_off_w.png" />
      </button>
    </div>
    <div class="overlay-video">
      <div class="text-container">
        <!-- <div class="headline">
          <img src="../assets/pomelo-bc-profilpic-edit.png" />
        </div> -->
        <!-- <div class="subheadline">years</div> -->
        <div class="audio">
          audio: POM21 | Alex Cortex - Soliton <br />video:
          <a href="http://dextro.org" target="_blank">Dextro</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoComponent",
  mounted() {
    const muteButton = document.getElementById("toggle-mute-btn");
    const video = document.getElementById("background-video");
    const muteImage = muteButton.querySelector("img");

    const toggleMute = () => {
      if (video.muted === true) {
        muteImage.src = require("@/assets/sound_on_w.png");
        video.muted = false;
      } else {
        muteImage.src = require("@/assets/sound_off_w.png");
        video.muted = true;
      }
    };

    muteButton.addEventListener("click", toggleMute);
  },
};
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-y: hidden;
}
.video-section {
  margin: 0;
  position: relative;
  height: 100%;
  overflow: hidden;
}
.video-container {
  /* position: relative;
  width: 100%;
  height: 100vh; */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: black;
  overflow: hidden;
  box-shadow: 0 4px 4px -2px gray;
}
.video-container video {
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%; */
  width: 80%;
  max-width: 800px;
  height: auto;
  z-index: 11;
  filter: hue-rotate(48deg) saturate(1.6) brightness(1.4);
}
.overlay-video {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  z-index: 12;
}
.video-container button {
  z-index: 13;
  position: absolute;
  top: 130px;
  left: 50px;
}
.text-container {
  position: relative;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  height: 100vh;
}
.headline {
  font-family: Roboto, sans-serif;
  font-size: 11rem;
  font-weight: bold;
  color: #feed01;
  opacity: 70%;
  margin-bottom: 0;
}
.headline img {
  width: 40%;
}
.subheadline {
  font-family: Roboto, sans-serif;
  font-size: 1.3rem;
  font-weight: bold;
  color: #feed01;
  opacity: 40%;
  text-align: center;
  margin-top: -25px;
}
.text-container .audio {
  position: absolute;
  bottom: 20px;
  left: 50px;
  font-family: Roboto, sans-serif;
  font-size: 0.7rem;
  color: #ccc;
  opacity: 80%;
}
#toggle-mute-btn {
  width: 70px;
  background-color: transparent;
  border: 0px;
  margin: 40px 40px;
  position: absolute;
  top: 70%;
  opacity: 50%;
}
#toggle-mute-btn img {
  width: 33px;
  opacity: 40%;
}
.audio a {
  color: #fff;
}
</style>
